import React from "react";
import Icon from "../ui/Icon";

// The bar under the board while one of Rook's lines is shown: the moves (click one to jump to it), step buttons,
// and a clear way back to the real position.
const LinePreviewBar = ({preview}) => {
    if (!preview.active) return null;
    const {line, step} = preview;
    const parts = line.label.split(" ");
    // Map label words to move indexes: words that are move numbers ("5." or "5...") belong to the next move
    let moveIndex = 0;
    const words = parts.map((word, i) => {
        if (/^\d+\.+$/.test(word)) return <span key={i} className="line-bar__num">{word}</span>;
        const index = moveIndex++;
        return (
            <button key={i} type="button" className={`line-bar__move ${index === step ? "current" : ""}`}
                    onClick={() => preview.go(index)}>
                {word}
            </button>
        );
    });
    const atEnd = step >= line.moves.length - 1;

    return (
        <div className="line-bar" role="region" aria-label="Rook's line">
            <div className="line-bar__top">
                <span className="line-bar__title">
                    {line.threat ? "The opponent's idea" : "Rook's line"}
                    <span className="line-bar__hint hide-sm"> · the board is paused, Esc to close</span>
                </span>
                <button type="button" className="btn btn-sm btn-primary" onClick={preview.close}>
                    <Icon name="close"/> Back to the position
                </button>
            </div>
            <div className="line-bar__moves">
                <button type="button" className={`line-bar__move ${step === -1 ? "current" : ""}`} onClick={() => preview.go(-1)}>Start</button>
                {words}
            </div>
            <div className="line-bar__controls">
                <button type="button" className="icon-btn" onClick={preview.prev} disabled={step < 0} aria-label="Previous move">
                    <Icon name="chevronLeft"/>
                </button>
                <button type="button" className="btn btn-sm" onClick={preview.togglePlay}>
                    {preview.playing ? "Pause" : atEnd ? "Play again" : "Play"}
                </button>
                <button type="button" className="icon-btn" onClick={preview.next} disabled={atEnd} aria-label="Next move">
                    <Icon name="chevronRight"/>
                </button>
            </div>
        </div>
    );
};

export default LinePreviewBar;
